module.exports = __webpack_public_path__ + "static/media/google_ad.e3ad2be5.svg";